
import { defineComponent } from "vue";
import SocialList from "@/components/SocialList.vue";

export default defineComponent({
  name: "App",
  components: { SocialList },
});
